import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';

const MoonIcon = () => (
  <svg width="20" height="20" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path fillRule="evenodd" clipRule="evenodd" d="M13.8955 8.5264C14.2255 8.3714 14.5775 8.6964 14.4855 9.0494C14.1714 10.2514 13.5545 11.3954 12.6045 12.3454C9.7835 15.1664 5.2705 15.2254 2.5225 12.4774C-0.225498 9.7294 -0.165498 5.2154 2.6555 2.3944C3.6055 1.4444 4.7485 0.827398 5.9515 0.513398C6.3045 0.421398 6.6285 0.773398 6.4745 1.1034C5.4725 3.2424 5.8015 5.8044 7.4985 7.5014C9.1945 9.1994 11.7565 9.5284 13.8955 8.5264Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SunIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="10" cy="10" r="4.375" fill="currentColor" fillOpacity="0.12" />
    <circle cx="10" cy="10" r="5" stroke="currentColor" strokeWidth="1.25" />
    <path d="M10 1.25V3.125M10 16.875V18.75M1.25 10H3.125M16.875 10H18.75M3.75 3.75L5 5M15 15L16.25 16.25M16.25 3.75L15 5M5 15L3.75 16.25" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
  </svg>
);

const ThemeToggle = () => {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === 'dark';

  return (
    <Button
      type="button"
      variant="second"
      size="icon"
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className="rounded-full border-0 bg-transparent p-[0.5rem] text-[#163A2E] transition-colors hover:bg-secondary dark:bg-transparent dark:text-white dark:hover:bg-[#292929]"
    >
      <span className="flex h-[2rem] w-[2rem] items-center justify-center">
        {isDark ? <SunIcon /> : <MoonIcon />}
      </span>
    </Button>
  );
};

export default ThemeToggle;
